















































import "@/assets/css/split.css";
import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import CreateModal from "./createmessagesendgroup.vue";
import EditModal from "./editmessagesendgroup.vue";
import DetailModal from './messagesendgroupdetail.vue';
import SearchTree from "@/lib/Common/searchtree";
import checkAuth from "@/lib/Common/checkauth";
import "@/assets/css/table.css";

class PageMessageSendGroupRequest extends PageRequest {
    keyword: string;
    organizationId: number;
}

@Component({
    components: { CreateModal, EditModal, DetailModal },
})
export default class MessageSendGroup extends AbpBase {
    //编辑
    async edit(id: string) {
        let res = await this.$store
            .dispatch({
                type: "messagesendgroup/get",
                id: id,
            })
            .catch((err) => {
                this.$Modal.info({
                    title: this.L("Tips"),
                    content: err,
                });
            });
        this.$store.commit("messagesendgroup/edit", res);
        this.editModalShow = true;
    }
    //明细
    async detail(id: number) {
        this.groupId = id;
        this.detailModalShow = true;
    }
    //filters
    pagerequest: PageMessageSendGroupRequest = new PageMessageSendGroupRequest();
    creationTime: Date[] = [];
    columnlist: any[] = [];
    areaTree: any[] = [];
    areaTreeList: any[] = [];
    searchName: string = "";
    createModalShow: boolean = false;
    editModalShow: boolean = false;
    detailModalShow: boolean = false;
    showcolumn: boolean = false; //显示列选择窗口
    splitnum: number = 0.15;
    groupId: number = 0;

    get list() {
        return this.$store.state.messagesendgroup.list;
    }
    get loading() {
        return this.$store.state.messagesendgroup.loading;
    }
    create() {
        this.createModalShow = true;
    }
    showcol() {
        this.showcolumn = true;
    }
    getItemId() {
        let item = (this.$refs.tree as any).getSelectedNodes();
        if (item.length > 0) {
            this.pagerequest.organizationId = item[0].id;
        }
        this.$store.commit("messagesendgroup/setCurrentPage", 1);
        this.getpage();
    }
    //搜索树形结构
    searchTree(value: any, treeList) {
        if (!value) {
            this.areaTree = this.areaTreeList;
            return;
        }
        this.areaTree = SearchTree.searnchTree(value, treeList);
    }
    //区域
    async getAreaTree() {
        await this.$store
            .dispatch("area/getAreaLeftTree")
            .then((val) => {
                this.areaTree = val;
                this.areaTreeList = val;
            })
            .catch((err) => {
                //return null;
            });
    }
    pageChange(page: number) {
        this.$store.commit("messagesendgroup/setCurrentPage", page);
        this.getpage();
    }
    pagesizeChange(pagesize: number) {
        this.$store.commit("messagesendgroup/setPageSize", pagesize);
        this.getpage();
    }
    async getpage() {
        this.pagerequest.maxResultCount = this.pageSize;
        this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
        await this.$store.dispatch({
            type: "messagesendgroup/getAll",
            data: this.pagerequest,
        });
    }
    get pageSize() {
        return this.$store.state.messagesendgroup.pageSize;
    }
    get totalCount() {
        return this.$store.state.messagesendgroup.totalCount;
    }
    get currentPage() {
        return this.$store.state.messagesendgroup.currentPage;
    }
    //列
    columns = [
        {
            title: this.L("Name"),
            key: "name",
            sortable: true,
        },
        {
            title: this.L("Organizations"),
            key: "organizationId",
            render: (h: any, params: any) => {
                let id = params.row.organizationId;
                let ite = JSON.parse(localStorage.getItem("organizations"));
                let info = ite.filter((p) => {
                    return p.id == id;
                });
                return h(
                    "span",
                    {
                        style: {
                            display: "inline-block",
                            width: "100%",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                        },
                        domProps: {
                            title: info.length > 0 ? info[0].displayName : this.L("Unknown"),
                        },
                    },
                    info.length > 0 ? info[0].displayName : this.L("Unknown")
                );
            },
        },
        {
            title: this.L("MessageType"),
            key: "sendType",
            sortable: true,
            render: (h: any, params: any) => {
                let str = this.L("Unknown");
                if (params.row.sendType == 1) {
                    str = this.L("SMSMessage");
                } else if (params.row.sendType == 2) {
                    str = this.L("Email");
                } else if (params.row.sendType == 3) {
                    str = this.L("MiniApp")
                }
                return h("span", str);
            },
        },
        {
            title: this.L("State"),
            key: "isEnabel",
            sortable: true,
            render: (h: any, params: any) => {
                if (params.row.isEnabel == true) {
                    return h('span', { style: { color: 'rgb(0, 101, 252)' } }, this.L("Actived"))
                } else if (params.row.isEnabel == false) {
                    this.L("NoActive");
                    return h('span', { style: { color: 'rgb(252, 0, 0)' } }, this.L("NoActive"))
                }
                return h("span", this.L("Unknown"));
            },
        },
        {
            title: this.L("Description"),
            key: "description",
            render: (h: any, params: any) => {
                return h(
                    "span",
                    {
                        style: {
                            display: "inline-block",
                            width: "100%",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                        },
                        domProps: {
                            title: params.row.description,
                        },
                    },
                    params.row.description
                );
            },
        },
        {
            title: this.L("Actions"),
            key: "Actions",
            fixed: "right",
            render: (h: any, params: any) => {
                return h("div", [
                    h(
                        "Button",
                        {
                            props: {
                                type: "primary",
                                size: "small",
                            },
                            style: {
                                marginRight: "5px",
                            },
                            on: {
                                click: () => {
                                    this.edit(params.row.id);
                                },
                            },
                        },
                        this.L("Edit")
                    ),
                    h(
                        "Button",
                        {
                            props: {
                                type: "success",
                                size: "small",
                            },
                            style: {
                                marginRight: "5px",
                            },
                            on: {
                                click: () => {
                                    this.detail(params.row.id);
                                },
                            },
                        },
                        this.L("Detail")
                    ),
                    h(
                        "Button",
                        {
                            props: {
                                type: "error",
                                size: "small",
                            },
                            on: {
                                click: async () => {
                                    this.$Modal.confirm({
                                        title: this.L("Tips"),
                                        content: this.L("DeleteConfirm"),
                                        okText: this.L("Yes"),
                                        cancelText: this.L("No"),
                                        onOk: async () => {
                                            await this.$store.dispatch({
                                                type: "messagesendgroup/delete",
                                                data: params.row,
                                            });
                                            await this.getpage();
                                        },
                                    });
                                },
                            },
                        },
                        this.L("Delete")
                    ),
                ]);
            },
        },
    ];
    async created() {
        this.getpage();
        this.getAreaTree();
    }
    data() {
        return {
            normalizer(node) {
                if (node.children && !node.children.length) {
                    delete node.children;
                }
                return {
                    id: node.id,
                    label: node.label,
                    children: node.children,
                };
            },
        };
    }
}
